const dateFormatSelectOptions: { [key: string]: string } = {
  'DD-MM-YYYY': 'DD-MM-YYYY',
  'YYYY-MM-DD': 'YYYY-MM-DD',
  YYYYMMDD: 'YYYYMMDD',
  DDMMYYYY: 'DDMMYYYY',
  'YYYY/MM/DD': 'YYYY/MM/DD',
  'DD/MM/YYYY': 'DD/MM/YYYY',
  'MM-DD-YYYY': 'MM-DD-YYYY',
  'MM/DD/YYYY': 'MM/DD/YYYY',
  MMDDYYYY: 'MMDDYYYY',
};

export default dateFormatSelectOptions;
